/**
 * @generated SignedSource<<bb240b22e09d0e349cbdc3cc16e0e4d3>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8

import type { ConcreteRequest } from 'relay-runtime';
export type FooterCreateButtonsQuery$variables = {
  spaceKey?: string | null;
};
export type FooterCreateButtonsQuery$data = {
  readonly space: {
    readonly didContainUserContent: boolean;
    readonly id: string | null;
    readonly key: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isDatabasesEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
  } | null;
};
export type FooterCreateButtonsQuery = {
  response: FooterCreateButtonsQuery$data;
  variables: FooterCreateButtonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isLivePagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isWhiteboardsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isDatabasesEnabled"
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "didContainUserContent"
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FooterCreateButtonsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FooterCreateButtonsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5841807a4e3bf2a59de617588db23f8f",
    "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
    "metadata": {},
    "name": "FooterCreateButtonsQuery",
    "operationKind": "query",
    "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "8f908e5cb8da1d069802e69ea3d7f563";

export default node;
